import { tokenize, type Token } from "./tokenize"

function escapeHtml(text: string): string {
  const map: Record<string, string> = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
  }
  return text.replace(/[&<>"']/g, (char) => map[char] || char)
}

function tokenToHtml(token: Token): string {
  const escaped = escapeHtml(token.content)
  switch (token.type) {
    case "bold":
      return `<strong>${escaped}</strong>`
    case "italic":
      return `<em>${escaped}</em>`
    case "strikethrough":
      return `<span style="text-decoration: line-through;">${escaped}</span>`
    case "code":
      return `<code style="background-color: rgba(0,0,0,0.06); border-radius: 3px; padding: 0.1em 0.3em; font-family: monospace;">${escaped}</code>`
    default:
      return escaped
  }
}

// Renders the same [BR]/**/*/_/~/` markers as FormattedText, but to an HTML string
// for contexts without a React tree (e.g. the print/export window).
export function formatTextToHtml(text: string | undefined): string {
  if (!text) return ""
  return text
    .split("[BR]")
    .map((line) => tokenize(line).map(tokenToHtml).join(""))
    .join("<br/>")
}
